import React from 'react';
import { Icon } from '@chakra-ui/react';
import { TriangleUpIcon, TriangleDownIcon } from '@chakra-ui/icons';
import { FiMinus } from 'react-icons/fi';

export const ParameterTrend = (props) => {
    const { trend } = props;

    if (trend === 'increasing') {
        return <TriangleUpIcon color='green.400' mr={2} />
    } else if (trend === 'decreasing') {
        return <TriangleDownIcon color='red.400' mr={2} />
    }

    return <Icon as={FiMinus} color='gray.500' mr={2} />
};
